import { render } from "./ColorPickerComponent.vue?vue&type=template&id=ebc11ba8&scoped=true"
import script from "./ColorPickerComponent.vue?vue&type=script&lang=js"
export * from "./ColorPickerComponent.vue?vue&type=script&lang=js"

import "./ColorPickerComponent.vue?vue&type=style&index=0&id=ebc11ba8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebc11ba8"]])

export default __exports__